<template>
  <div id="content-wrapper">
    <b-form-group class="border-bottom-form">
      <div class="row m-0">
        <div class="col-xl-5 col-lg-6 p-0 d-flex align-items-center">
          <b-form-input
            v-if="false"
            @keyup.enter="layDanhSachPermission"
            id="filterBy"
            placeholder="Nhập từ khóa tìm kiếm"
            required
            type="text"
            v-model="requestInformation.filterBy"
          />
          <div class="font-weight-bold">Tên ứng dụng</div>
          <v-select
            class="ml-2 flex-1-0"
            :options="listAppPermissions"
            id="id"
            label="name"
            :reduce="(app) => app.id"
            v-model="requestInformation.appId"
            :readonly="true"
            placeholder="Chọn ứng dụng"
            :disabled="isIframe"
          >
            <span slot="no-options"> Không tìm thấy dữ liệu </span></v-select
          >
        </div>
        <div class="ml-2" v-if="false">
          <base-button button="Tìm kiếm" @click="layDanhSachPermission()" />
        </div>
      </div>
    </b-form-group>
    <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
    <DataTable
      :loading="isLoadingTable"
      :value="items"
      dataKey="id"
      class="p-datatable-customers"
    >
      <Column
        field="id"
        dataKey="id"
        headerStyle="width: 40px"
        headerClass="p-2"
        header="STT"
        bodyStyle="text-align: center"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>{{
            (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
          }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="displayName"
        header="Mã quyền"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.PermissionCode"
            @change="layDanhSachPermission"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.name }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="name"
        header="Tên quyền"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.PermissionName"
            @change="layDanhSachPermission"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.displayName }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="appName"
        header="Ứng dụng"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.ApplicationName"
            @change="layDanhSachPermission"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.appName }}</span>
        </template>
      </Column>
      <template #empty
        ><div class="text-center">Không có dữ liệu</div></template
      >
      <template #loading
        ><div class="text-center">Đang tải dữ liệu ...</div>
      </template>
    </DataTable>

    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />
  </div>
</template>
<script>
import BasePagination from "@/components/common/BasePagination";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import { NO_RESULTS_TEXT } from "@/constants/constants";
import _isNil from "lodash/isNil";
import {
  LOCAL_STORAGE_KEY,
  setValueToStorageByKey,
} from "@/utils/localStorage";

export default {
  name: "DanhSachQuyenTrongApp",
  components: {
    BasePagination,
  },
  data() {
    return {
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      items: [],
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      requestInformation: {
        appId: null,
        filterBy: "",
        pageSize: 10,
        pageIndex: 1,
      },
      requestForm: {},
    };
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/tatCaApp",
      danhSachPermissionTheoApp: "permission/danhSachQuyenTrongAppPaging",
      appId: "common/appId",
      isIframe: "common/isIframe",
      listApp: "app/listApp",
    }),
    listAppPermissions() {
      if(this.listApp && this.listApp.length > 0) {
        let convertDataListApp = this.listApp.map((item) => {
          return {
            ...item,
            code: item.appCode
          }
        })
        let arrayData = []
        this.danhSachApp.forEach((item) => convertDataListApp.forEach((item2) => {
          if(item.code === item2.code) {
            arrayData.push(item)
          }
        }))
        return arrayData
      }
      return []
    },
    hasPageData() {
      return !_isEmpty(this.items);
    },
  },
  watch: {
    appId: {
      handler() {
        this.requestInformation.appId = this.appId;
      },
    },
    "requestInformation.appId": {
      handler() {
        this.layDanhSachPermission();
        this.requestInformation.pageIndex = 1;
        setValueToStorageByKey(
          LOCAL_STORAGE_KEY.APP_ID,
          this.requestInformation.appId
        );
        this.$store.dispatch("common/setAppId", this.requestInformation.appId);
      },
      deep: true,
    },
    danhSachPermissionTheoApp: {
      handler() {
        this.totalPages = this.danhSachPermissionTheoApp.totalPage;
        this.totalRows = _isNil(this.danhSachPermissionTheoApp.totalCount)
          ? 0
          : this.danhSachPermissionTheoApp.totalCount;
        if (!_isEmpty(this.danhSachPermissionTheoApp)) {
          this.items = this.danhSachPermissionTheoApp.items;
        }
      },
      deep: true,
    },
  },
  async created() {
    // this.requestInformation.appId = this.appId;
    this.layDanhSachApp();
    this.layDanhSachPermission();
    this.$store.dispatch("app/getListApp");
  },
  methods: {
    getInternalForm() {
      return this.internalForm;
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    layDanhSachPermission() {
      this.isLoadingTable = true;
      this.$store
        .dispatch("permission/layDanhSachQuyenTheoAppPaging", {
          ...this.requestInformation,
          ...this.requestForm,
        })
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachPermission();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachPermission();
    },
  },
};
</script>
